module.exports = __webpack_public_path__ + "static/media/55_000083.f94be6b8.jpg";